// Single entry point for tag-container events. Adobe keeps its own contract in
// adobe-analytics.js — the two payload shapes are unrelated and neither should
// bend to the other.
//
// Bot traffic still pushes: the container cannot suppress its own automatic
// page_view, so filtering ours at the source would deflate engagement against
// inflated page views. The seed exposes isBot for container-side exclusion.

// GA4's ecommerce events. GTM's GA4 tags read items and revenue from an
// ecommerce key; every other event stays flat because the container reads
// params like lead_type at the top level.
const ECOMMERCE_EVENTS = [
  'add_payment_info',
  'add_shipping_info',
  'add_to_cart',
  'add_to_wishlist',
  'begin_checkout',
  'purchase',
  'refund',
  'remove_from_cart',
  'select_item',
  'select_promotion',
  'view_cart',
  'view_item',
  'view_item_list',
  'view_promotion',
];

export const pushDataLayerEvent = (name, params = {}) => {
  if (!name) return;

  window.dataLayer = window.dataLayer || [];
  if (ECOMMERCE_EVENTS.includes(name)) {
    // GTM merges every push into one model, so the previous event's items
    // would otherwise carry into this one.
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({ event: name, ecommerce: params });
  } else {
    window.dataLayer.push({ event: name, ...params });
  }

  // Same event, same name, into the property we own — so a number quoted from
  // a dashboard we cannot see is one we can check. gtag takes the flat form
  // whatever the event.
  if (typeof window.threeformGtag === 'function') {
    window.threeformGtag('event', name, params);
  }
};
